import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { AccountSandbox } from "src/core/account/account.sandbox";
import { MessageService } from "src/core/services/messages.service";

@Component({
    templateUrl: './users-import.dialog.html',
    styleUrls: ['./users-import.dialog.scss']
})
export class UsersImportDialogComponent implements OnInit, OnDestroy {
    private subs: Subscription[] = [];

    file: File;
    fileURL: any;

    constructor(
        public accauntSandbox: AccountSandbox,
        private message: MessageService,
        private dialogRef: MatDialogRef<UsersImportDialogComponent>
    ) {
        this.accauntSandbox.doClearImportUsersFromFileState();
    }

    ngOnInit(): void {
        this.subs.push(this.accauntSandbox.importUsersFromFileData$.subscribe(res => {
            if (res) {
                this.dialogRef.close(true);
                this.message.log('Success!')
            }
        }))
        this.subs.push(this.accauntSandbox.importUsersFromFileFailData$.subscribe(res => {
            if (res) {
                this.message.log('Server error!');
            }
        }))
    }

    upload(): void {
        if (this.file) {
            const params: FormData = new FormData();
            params.append('file', this.file, this.file.name);

            this.accauntSandbox.doImportUsersFromFile(params)
        }
    }

    onFileChanged(event: any): void {
        const f: File = event.target.files[0] as File;

        if (f && f.size < 31457280) {
            this.file = f;
            const reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onload = (e) => {
                this.fileURL = reader.result.toString();
            };
        } else {
            this.message.log('File size must be lowerest than 30 mb');
        }
    }

    ngOnDestroy(): void {
        this.subs.map(s => s.unsubscribe());
    }
}